export const getPageMargins = () => {
    return `@page { margin: 1cm 1cm 1cm 1cm !important; }`;
};

export const getPageMarginsZero = () => {
    return `@page { margin: 0cm 0cm 0cm 0cm !important; }`;
};